import { IndexDBService } from './IndexDBService';

const DB_NAME = 'StampSuggestion';
const DB = new IndexDBService(DB_NAME);

// const tables = [{}];

export default class DBService {
  static support() {
    return DB.support();
  }

  static exists() {
    return DB.exists();
  }

  static supportAndExist() {
    return DB.checkSupportAndExist();
  }

  static removeDB() {
    return DB.remove();
  }

  static createDB(tables) {
    return DB.create(tables);
  }

  static writeVersion(version) {
    return DB.insert('revision', { version: version, key: 'version' });
  }

  static updateVersion(version) {
    return DB.update('revision', { version: version, key: 'version' });
  }

  static writeLangs(langs) {
    return DB.insert('lang', { list: langs, key: 'list' });
  }

  static insertKeywordItems(tableName, keywords) {
    const items = Object.keys(keywords).map((x) => {
      return { segment: x, matches: keywords[x] };
    });
    return DB.insertAsBatch(tableName, items);
  }

  static async queryVersion() {
    const table = 'revision';
    const [error, result] = await DB.query(table, 'version');

    if (error) {
      return null;
    } else {
      if (result) {
        return result.version;
      } else {
        return null;
      }
    }
  }

  static async queryLanguages() {
    const [error, result] = await DB.query('lang', 'list');
    if (error) {
      return null;
    } else {
      return result;
    }
  }

  static async queryLangMatching(lang, input, onlyEmoj) {
    const [error, result] = await DB.query(lang, input);
    if (error) {
      return [];
    } else if (result === null) {
      return [];
    } else {
      return result.matches
        .map(function (x) {
          if (!x) {
            return null;
          }
          let extra = x.detail;
          if (x.type === 'S') {
            if (onlyEmoj) {
              return null;
            } else {
              return {
                packageId: extra[0],
                stickerId: extra[1],
                type: x.type,
                id: x.id,
              };
            }
          } else if (x.type === 'C') {
            return {
              packageId: extra[0],
              packageVersion: extra[1],
              emojiUnicode: extra[2],
              type: x.type,
              id: x.id,
            };
          }
        })
        .filter(function (x) {
          return x;
        });
    }
  }
}
